import { Skeleton } from "@mui/material";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
} from "../../../../components";
import PainelAnaliseFiscalProdutosGrupoTributarioDialog from "./painel-analise-fiscal-produtos-grupo-tributario-dialog";
import { useState } from "react";
import shortid from "shortid";

export default function PainelAnaliseFiscalProdutosGrupoTributario({
  loading = false,
  analiseFiscalAi = {
    produtosAnalisados: 0,
    ncmsComInconsistencia: 0,
    gruposTributacaoIncorretos: 0,
    ncmsInconsistentes: [],
    gruposIncorretos: [],
  },
  revisarProdutoAnaliseFiscal,
  gruposTributacao = [],
}) {
  const [
    openDialogProdutosGrupoTributario,
    setOpenDialogProdutosGrupoTributario,
  ] = useState(false);

  return (
    <Grid item xs={12} md={6}>
      <Card
        sx={{
          borderRadius: 3,
          border: "1px solid #f0f0f0",
          height: "100%",
        }}
      >
        <CardContent sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <div>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                Grupos de tributação incorretos
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                Grupos incompatíveis com a natureza do produto
              </Typography>
            </div>
            {analiseFiscalAi.gruposIncorretos?.length > 0 && (
              <Box display="flex" justifyContent="end">
                <Button
                  variant="outlined"
                  color="warning"
                  size="small"
                  className="gap-2"
                >
                  Revisar Grupos Tributários
                  <i
                    className="ph-bold ph-arrow-square-out"
                    style={{ color: "#64748b", fontSize: 15 }}
                  />
                </Button>
              </Box>
            )}
          </Box>
          <Divider sx={{ mb: 2 }} />
          {loading ? (
            <Box>
              {[1, 2, 3, 4].map((i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  height={40}
                  sx={{ mb: 1, borderRadius: 1 }}
                />
              ))}
            </Box>
          ) : (
            <Box>
              <Table size="small" className="mt-3">
                <TableHead sx={{ backgroundColor: "#f8fafc" }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700, minWidth: 250 }}>
                      Produto
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>
                      Grupo Tributário Atual
                    </TableCell>
                    <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>
                      Grupo Tributário Sugerido
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {analiseFiscalAi.gruposIncorretos.map((item, idx) => (
                    <TableRow
                      key={item.descricao || idx}
                      sx={{ "&:hover": { backgroundColor: "#f8fafc" } }}
                    >
                      <TableCell>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          {item.descricao || "—"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            gruposTributacao.find(
                              (g) => g.csoSimplesNacional == item.csoCodigo,
                            )?.nome || "—"
                          }
                          size="small"
                          color="primary"
                        />
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={
                            gruposTributacao.find(
                              (g) => g.csoSimplesNacional == item.csoSugerido,
                            )?.nome || "—"
                          }
                          size="small"
                          color="success"
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
        </CardContent>
      </Card>
      <PainelAnaliseFiscalProdutosGrupoTributarioDialog
        open={openDialogProdutosGrupoTributario}
        setOpen={setOpenDialogProdutosGrupoTributario}
        gruposTributacao={gruposTributacao}
        revisarProdutoAnaliseFiscal={revisarProdutoAnaliseFiscal}
        gruposIncorretos={(analiseFiscalAi.gruposIncorretos || []).map(
          (item) => ({
            ...item,
            id: shortid.generate(),
          }),
        )}
      />
    </Grid>
  );
}
